import { ProjectPopover } from "@/components/popovers/project-popover";
import { ColoredIcon } from "@msuite/ui/icons";
import { Link } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { Popover } from "@msuite/ui/popover";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { createdAtFormatter } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { ResourceLinkListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ResourceLinkListItem>();

export const columns = [
	columnHelper.accessor((row) => row.name ?? guardString(null), {
		id: "name",
		header: localized("resource_links.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("link", {
		id: "link",
		header: "Link",
		cell: (cell) => <Link href={cell.getValue()}>{cell.getValue()}</Link>,
	}),
	columnHelper.accessor("projectName", {
		id: "project",
		header: localized("projects.project"),
		cell: (cell) => (
			<Popover
				trigger="click"
				variant="plain"
				render={() => <ProjectPopover projectId={cell.row.original.projectId} />}
			>
				<p>{cell.getValue()}</p>
			</Popover>
		),
	}),
	columnHelper.accessor((row) => row.ticketDescription ?? guardString(null), {
		id: "ticket",
		header: localized("projects.ticket"),
		cell: (cell) => {
			const row = cell.row.original;
			if (!row.ticketId) return guardString(null);
			return (
				<div className="h-stack">
					<ColoredIcon
						iconName={row.ticketIconName ?? undefined}
						color={row.ticketColor ?? undefined}
					/>
					<p>{row.ticketDescription}</p>
				</div>
			);
		},
	}),
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	createRowActions(RowActions),
];
